import { Area, Branch, CartItem, City, OpeningHours } from "../types/item";
import { Bootstrap, PaymentOption } from "../types/app";
import { ActionType, OrderType } from "../types/enums";
import InitialValues from "./initialValues";
import { createContext } from "react";

interface Props {
  isReady?: boolean;
  cart?: {
    tax: number;
    subtotal: number;
    items: CartItem[];
    taxPercent: number;
    grandtotal: number;
    deliveryCharges: number;
  };
  cartItems: CartItem[];
  bootstrap?: Bootstrap;
  logoUrl?: string;
  banners?: { url: string; link?: string | null }[];
  openingHours?: OpeningHours[];
  deliveryTime?: string;
  minimumOrder?: number;
  cities?: City[];
  areas?: Area[];
  payments?: PaymentOption[];
  isSiteActive?: boolean;
  location?: {
    city?: City;
    area?: Area;
    branch?: Branch;
    orderType?: OrderType;
    openingHours?: OpeningHours;
  };
  dispatch: (action: { type: ActionType; payload: any }) => void;
}

const AppContext = createContext<Props>({
  ...InitialValues.app,
  dispatch: () => {},
});

export default AppContext;
